import { createFileRoute } from '@tanstack/react-router';
import { SelectEventPage } from '@pages/select-event';

export const Route = createFileRoute('/select-event')({
  component: SelectEventPage,
});
